import { formatDuration as dateFnsFormatDuration } from 'date-fns';

import type { Duration, DurationUnit, Locale } from 'date-fns';

type FormatDurationOptions = {
  /** Duration units to include in output (defaults to ['hours', 'minutes']) */
  format?: DurationUnit[];
  /** date-fns locale object */
  locale?: Locale;
};

/**
 * Format a Duration object into a human-readable string
 *
 * @param duration - Duration object with time units
 * @param options - Formatting options
 * @param options.locale - date-fns locale object
 * @param options.format - Duration units to include (defaults to ['hours', 'minutes'])
 *
 * @returns Formatted duration string (e.g., "30 хвилин", "1 година 30 хвилин")
 *
 * @example
 * ```ts
 * import { uk } from 'date-fns/locale'
 *
 * // 30 minutes
 * formatDuration({ minutes: 30 }, { locale: uk })
 * // => "30 хвилин"
 *
 * // 1 hour 30 minutes
 * formatDuration({ hours: 1, minutes: 30 }, { locale: uk })
 * // => "1 година 30 хвилин"
 *
 * // 2 hours
 * formatDuration({ hours: 2 }, { locale: uk })
 * // => "2 години"
 * ```
 */
export const formatDuration = (
  duration: Duration,
  { format = ['hours', 'minutes'], locale }: FormatDurationOptions = {},
): string =>
  dateFnsFormatDuration(duration, {
    format,
    locale,
  });
